import { v4 as uuidv4 } from "uuid";

import { ActionPriority } from "constants/actions";
import { INTEREST_PREVIEW } from "constants/actionTypes";
import { CreditDebit } from "constants/interest";

export interface InterestPreviewRequest {
  chargeToDate: string;
  chargeFromDate?: string | null;
  creditDebit?: CreditDebit;
  businessIds?: string[];
}

export const INTEREST_URL = "/v2/interest/";
export const INTEREST_PREVIEW_URL = "/v2/interest/preview/";

export const serializeInterestRequest = ({
  chargeToDate,
  chargeFromDate,
  creditDebit,
  businessIds,
}: InterestPreviewRequest) => ({
  charge_to_date: chargeToDate,
  charge_from_date: chargeFromDate || null,
  credit_debit: creditDebit,
  business_ids: businessIds ?? [],
});

export const InterestPreviewAction = {
  reset: () => ({ type: INTEREST_PREVIEW.FETCH_BULK.RESET }),
  request: (scope: InterestPreviewRequest) => {
    // Lets the reducer drop responses to requests superseded by a newer
    // request or a reset.
    const requestId = uuidv4();
    return {
      type: INTEREST_PREVIEW.FETCH_BULK.REQUEST,
      meta: {
        requestId,
        allowConcurrent: true,
        priority: ActionPriority.MEDIUM,
        offline: {
          effect: {
            url: INTEREST_PREVIEW_URL,
            method: "POST",
            body: JSON.stringify(serializeInterestRequest(scope)),
          },
          commit: {
            type: INTEREST_PREVIEW.FETCH_BULK.SUCCESS,
            meta: { requestId },
          },
          rollback: {
            type: INTEREST_PREVIEW.FETCH_BULK.FAILURE,
            meta: { requestId },
          },
        },
      },
    };
  },
  create: (scope: InterestPreviewRequest) => ({
    type: INTEREST_PREVIEW.CREATE.REQUEST,
    meta: {
      priority: ActionPriority.MEDIUM,
      offline: {
        effect: {
          url: INTEREST_URL,
          method: "POST",
          body: JSON.stringify(serializeInterestRequest(scope)),
        },
        commit: {
          type: INTEREST_PREVIEW.CREATE.SUCCESS,
        },
        rollback: {
          type: INTEREST_PREVIEW.CREATE.FAILURE,
        },
      },
    },
  }),
};
